/* Simple Pledge Wunschgravur-Erweiterung (10.10.2026)
   Ergänzt den bestehenden Konfigurator (sl-product-configurator.js) ohne ihn zu verändern:
   Live-Vorschau der Gravur, Schritt-Nummern, Ideen zum Antippen, Kaufleiste (mobil).
   Liest nur aus dem Konfigurator-DOM und löst für Ideen ein normales input-Event aus. */
(function () {
  'use strict';
  function init() {
    var cfg = document.querySelector('[data-sp-engrave]');
    var input = document.getElementById('input-textarea');
    if (!cfg || !input || cfg.dataset.bound) return;
    cfg.dataset.bound = '1';
    var max = parseInt(input.getAttribute('data-max-length') || '40', 10);
    var scope0 = function () { return document.getElementById('sl-product-configurator') || document; };
    var shape = cfg.dataset.shape || 'bar';
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

    /* ---------- Vorschau ---------- */
    var box = document.createElement('div');
    box.className = 'spe-prev spe-prev--' + shape;
    box.innerHTML = '<div class="spe-stage"><span class="spe-cord spe-cord--l"></span><div class="spe-plate"><div class="spe-text" aria-live="polite"></div></div><span class="spe-cord spe-cord--r"></span></div>' +
      '<p class="spe-note"><span>Vorschau deiner Gravur</span><span class="spe-count"></span></p>';
    var anchor = input.closest('.configurator-block__input') || input.parentNode;
    anchor.parentNode.insertBefore(box, anchor);
    var plate = box.querySelector('.spe-plate'), txt = box.querySelector('.spe-text'), count = box.querySelector('.spe-count');

    function val(name) {
      var r = document.querySelector('input[data-variant-input][name="' + name + '"]:checked');
      return r ? r.value : '';
    }
    function metal() {
      var f = (val('Farbe') || cfg.dataset.defaultColor || '').toLowerCase();
      if (/schwarz|black/.test(f) || cfg.dataset.black === 'true') return 'black';
      if (/ros/.test(f)) return 'rose';
      if (/gold/.test(f)) return 'gold';
      return 'silver';
    }
    var CORDS = { schwarz: '#1d1d1d', black: '#1d1d1d', 'weiß': '#efece6', weiss: '#efece6', grau: '#8d8d8d', rot: '#a3222b', blau: '#24406e', navy: '#1f2b4a', rosa: '#e5b3bd', beige: '#d8c3a5', braun: '#6b4a32', 'grün': '#3c5f45', gruen: '#3c5f45', lila: '#6d4c8c', gold: '#c9a45c', silber: '#bfc3c7' };
    function cordColor() {
      var b = (val('Bandfarbe') || '').toLowerCase(), c = null;
      Object.keys(CORDS).some(function (k) { if (b.indexOf(k) > -1) { c = CORDS[k]; return true; } return false; });
      return c || '#1d1d1d';
    }
    function type() {
      var s = document.querySelector('.types__button.selected');
      return ((s && s.getAttribute('data-type')) || '').toLowerCase();
    }
    function render() {
      var html = '', n = 0;
      Array.prototype.forEach.call(input.childNodes, function (node) {
        if (node.nodeName === 'IMG') { html += '<img src="' + esc(node.src) + '" alt="">'; n++; }
        else if (node.nodeType === 3) { html += esc(node.textContent.toUpperCase()); n += node.textContent.length; }
        else if (node.textContent) { html += esc(node.textContent.toUpperCase()); n += node.textContent.length; }
      });
      var empty = !n;
      txt.innerHTML = empty ? '<span class="spe-ph">DEINE GRAVUR</span>' : html;
      box.dataset.metal = metal();
      box.dataset.type = /blind/.test(type()) ? 'blind' : (/white|weiß|weiss/.test(type()) ? 'white' : 'black');
      box.style.setProperty('--cord', cordColor());
      count.textContent = n + ' / ' + max + ' Zeichen';
      count.classList.toggle('is-over', n > max);
      fit();
      sticky();
    }
    function fit() {
      var maxSize = shape === 'circle' ? 20 : (shape === 'wide' ? 22 : (shape === 'slim' ? 15 : 18)), size = maxSize;
      txt.style.fontSize = size + 'px';
      var w = plate.clientWidth * (shape === 'circle' ? 0.78 : 0.9), h = plate.clientHeight * 0.86;
      var guard = 0;
      while ((txt.scrollWidth > w || txt.scrollHeight > h) && size > 8 && guard++ < 30) { size -= 1; txt.style.fontSize = size + 'px'; }
    }
    new MutationObserver(render).observe(input, { childList: true, characterData: true, subtree: true });
    input.addEventListener('input', render);
    document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('input[data-variant-input]')) setTimeout(render, 30); });
    document.addEventListener('click', function (e) { if (e.target.closest('.types__button')) setTimeout(render, 30); });
    window.addEventListener('resize', fit, { passive: true });

    /* ---------- Symbole unter das Eingabefeld (vorher zwischen Überschrift und Feld – verwirrend) ---------- */
    var syms = scope0().querySelector('.configurator__symbols');
    var inputWrap = input.closest('.input__container') || input.parentNode;
    if (syms && !syms.closest('.spe-symbols')) {
      var symBox = document.createElement('div');
      symBox.className = 'spe-symbols';
      symBox.innerHTML = '<span class="spe-symbols-l">Symbol einfügen <small>(an der Cursor-Position)</small></span>';
      symBox.appendChild(syms);                       // Knoten verschieben – Klick-Handler des Konfigurators bleiben erhalten
      inputWrap.insertAdjacentElement('afterend', symBox);
      // Steht der Cursor nicht im Feld, Symbol ans Ende setzen (sonst fügt der Konfigurator nichts ein)
      syms.addEventListener('pointerdown', function () {
        var sel = window.getSelection();
        if (sel && sel.rangeCount && input.contains(sel.anchorNode)) return;
        try { var r = document.createRange(); r.selectNodeContents(input); r.collapse(false); sel.removeAllRanges(); sel.addRange(r); } catch (e) {}
      }, true);
    }

    /* ---------- Ideen zum Antippen ---------- */
    var ideas = [];
    try { ideas = JSON.parse(cfg.dataset.ideas || '[]'); } catch (e) {}
    ideas = ideas.filter(function (i) { return i.t && i.t.length <= max; });
    if (ideas.length) {
      var chips = document.createElement('div');
      chips.className = 'spe-ideas';
      chips.innerHTML = '<span class="spe-ideas-l">Ideen:</span>' + ideas.map(function (i) { return '<button type="button" data-t="' + esc(i.t) + '">' + esc(i.l) + '</button>'; }).join('');
      (document.querySelector('.spe-symbols') || inputWrap).insertAdjacentElement('afterend', chips);
      chips.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-t]'); if (!b) return;
        input.textContent = b.dataset.t;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        try { var r = document.createRange(); r.selectNodeContents(input); r.collapse(false); var s = getSelection(); s.removeAllRanges(); s.addRange(r); input.focus({ preventScroll: true }); } catch (x) {}
      });
    }

    /* ---------- Schritt-Nummern ---------- */
    var scope = document.getElementById('sl-product-configurator');
    var info = scope ? (scope.closest('.sl-product__info, .product-single__meta, form, .grid__item') || document) : document;
    var titles = Array.prototype.filter.call(info.querySelectorAll('.sl-product--option__title'), function (t) {
      return !t.classList.contains('hidden-label') && t.offsetParent !== null && !t.querySelector('.spe-step');
    });
    // nur bis zur Gravur-Eingabe nummerieren (optionale Extras wie die Karte danach nicht)
    var engrTitle = scope && scope.querySelector('.configurator-block__symbol .sl-product--option__title');
    var stop = titles.indexOf(engrTitle);
    if (stop > -1) titles = titles.slice(0, stop + 1);
    titles.forEach(function (t, i) { t.insertAdjacentHTML('afterbegin', '<span class="spe-step">' + (i + 1) + '</span>'); });

    /* ---------- Kaufleiste (mobil) ---------- */
    var openBtn = document.getElementById('configurator-modal-open');
    var bar = document.createElement('div');
    bar.className = 'spe-bar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="spe-bar-t"><span class="spe-bar-g"></span><strong class="spe-bar-p"></strong></div><button type="button" class="spe-bar-b"></button>';
    document.body.appendChild(bar);
    var priceSrc = document.querySelector('[data-product-price]') || document.querySelector('.sl-product__price') || document.querySelector('.product__price');
    var barBtn = bar.querySelector('.spe-bar-b');
    var btnVisible = true, pastTop = false;
    function sticky() {
      var n = parseInt(input.getAttribute('data-length') || '0', 10) || input.textContent.length || input.querySelectorAll('img').length;
      var ok = n > 0 && input.getAttribute('data-valid') !== 'false';
      barBtn.textContent = ok ? 'Weiter zur Prüfung' : 'Gravur eingeben';
      bar.querySelector('.spe-bar-g').textContent = n ? (txt.textContent || '').slice(0, 26) : 'Deine Wunschgravur';
      if (priceSrc) bar.querySelector('.spe-bar-p').textContent = (priceSrc.textContent || '').trim().replace(/\s+/g, ' ');
      var on = !btnVisible && pastTop;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    barBtn.addEventListener('click', function () {
      var ok = input.textContent.trim().length > 0 || input.querySelector('img');
      if (ok && openBtn && !openBtn.disabled) { openBtn.click(); return; }
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 400);
    });
    if (openBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { btnVisible = e.isIntersecting; sticky(); }); }).observe(openBtn);
    }
    window.addEventListener('scroll', function () { var p = window.scrollY > 500; if (p !== pastTop) { pastTop = p; sticky(); } }, { passive: true });

    render();
  }
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();
